import TicketEventType from '../components/menus/ticket/enums/eventType'
import { mapGetters, mapMutations } from 'vuex'
import moment from 'moment'

const wsConnection = {
  created () {
    this.$eventBus.$on('ticket-socket-connection-success', () => {
      this.ticketBrandSubscribe(this.ticketBrandId)
    })
    // 브랜드 정보 변경시
    this.$eventBus.$on(TicketEventType.REFRESH_TICKET_COUNT, () => {
      if (this.IS_TICKET_CONNECTED) {
        this.ticketBrandId = this.currentTicketBrandId
        // 현재 구독 해제 후
        this.forceTicketCloseSubscription()
        // 새로운 브랜드로 구독한다.
        this.ticketBrandSubscribe()
      }
    })

    this.$eventBus.$on('call-api-reconnect-start', () => {
      this.retryCallApiConnect()
    })

    this.$eventBus.$on('call-api-socket-connection-success', () => {
      this.callApiCallbackkSubscribe()
    })

    this.$eventBus.$on('status-reconnect-start', () => {
      if (this.callMode === 'KT') {
        this.retryStatusConnect()
      }
    })
  },
  beforeDestroy () {
    this.$eventBus.$off('ticket-socket-connection-success')
    this.$eventBus.$off(TicketEventType.REFRESH_TICKET_COUNT)
    this.$eventBus.$off('TRIGGER_DRAWER_HANDLER')
    this.$eventBus.$off('call-api-reconnect-start')
    this.$eventBus.$off('status-reconnect-start')
  },
  computed: {
    ...mapGetters([
      'loginId',
      'currentBrandId',
      'callApiUserId',
      'IS_TICKET_CONNECTED',
      'currentTicketBrandId',
      'IS_CALL_API_CONNECTED',
      'callMode',
      'IS_CONNECTED'
    ])
  },
  data () {
    return {
      isUseCall: false,
      callRetryCount: 0,
      statusRetryCount: 0,
      callApiRetryCount: 0,
      ticketBrandId: 0,
      myTicketShow: true,
      allTicketShow: true,
      recentTicketShow: true,
      resolvedTicketShow: true,
      ticketCounts: {
        myTicket: 0,
        allTicket: 0,
        recentUpdatedTicket: 0,
        resolvedTicket: 0
      },
      pmsKey: 'CALL_OPERATION',
      isPermission: false,
      callType: {
        KT: 'KT_CALL',
        NEOMECCA: 'CALL'
      }
    }
  },
  methods: {
    ...mapMutations([
      'changeTicketBrandId',
      'changeCallApiUserId',
      'callApiSubScribe',
      'changeIsExistCallAgent',
      'ticketSubScribe',
      'forceTicketCloseSubscription',
      'subscribe'
    ]),
    checkUseCall () {
      this.isPermission = this.$checkAction(this.pmsKey)

      this.axios.get('/api/brand/isUsableModuleChannel', {
        params: {
          brandId: this.currentBrandId || this.brandId,
          moduleName: 'CALL',
          channelName: this.callType[this.callMode]
        }
      }).then(result => {
        if (result.data.code === 0) {
          this.isUseCall = true
        } else {
          this.isUseCall = false
          this.changeIsExistCallAgent(false)
          this.$eventBus.$emit('set-call-agent')
        }
      }).then(() => {
        this.$store.dispatch('setCallAgentInfo').then(() => {
          this.retryCallConnect()
          if (this.callMode === 'KT') {
            this.retryStatusConnect()
          }
        })
      }).then(() => {
        /* call Socket 연결 */
        if (!this.IS_CALL_API_CONNECTED || this.callApiUserId !== this.loginId) {
          this.retryCallApiConnect()
        }
      })
    },
    connectTicket: function () {
      this.axios.get(`/gateway/ticket/agent/${this.ticketAgentId}/brands`).then(result => {
        if (result.data.code === 0) {
          const use = result.data.data.filter(brand => brand.useStatus === 'ENABLE')
          if (use && use.length > 0) {
            this.useBrand = use.length
            this.ticketBrandId = use[0].id
            this.changeTicketBrandId(use[0].id)
          }
          if (this.IS_TICKET_CONNECTED) {
            this.ticketBrandSubscribe(result.data.id)
          } else {
            this.$store.dispatch('ticket_connect')
          }
        }
      })
    },
    ticketBrandSubscribe: function () {
      this.ticketSubScribe({
        subscribeUrl: `/api/ticket/subscribe/brand/${this.ticketBrandId}`,
        callBack: this.updateTicketCount
      })
    },
    updateTicketCount (data) {
      // 이벤트 받는 부분을 5초의 쿨다운을 적용.
      if (data && this.ticketBrandId === data.brandId) {
        // JS deep Copy 를 위해 json 객체 사용.
        let oldVal = JSON.parse(JSON.stringify(this.ticketCounts))
        if (data.agentId && data.agentId === this.ticketAgentId && data.myTicketsCount !== undefined) {
          this.ticketCounts.myTicket = data.myTicketsCount
          this.ticketCounts.allTicket = data.AllTicketsCount
          this.ticketCounts.recentUpdatedTicket = data.recentUpdatedTicketsCount
          this.ticketCounts.resolvedTicket = data.resolvedTicketsCount
        } else {
          this.ticketCounts.allTicket = data.AllTicketsCount
          this.ticketCounts.recentUpdatedTicket = data.recentUpdatedTicketsCount
          this.ticketCounts.resolvedTicket = data.resolvedTicketsCount
        }
        this.ticketCountEventListener(oldVal, this.ticketCounts)
      }
    },
    ticketCountEventListener (oldVal, newVal) {
      if (oldVal.myTicket !== newVal.myTicket) {
        this.handleUpdateEvent('myTicket')
      }
      if (oldVal.allTicket !== newVal.allTicket) {
        this.handleUpdateEvent('allTicket')
      }
      if (oldVal.recentUpdatedTicket !== newVal.recentUpdatedTicket) {
        this.handleUpdateEvent('recentTicket')
      }
      if (oldVal.resolvedTicket !== newVal.resolvedTicket) {
        this.handleUpdateEvent('resolvedTicket')
      }
    },
    handleUpdateEvent (type) {
      if (type === 'myTicket') {
        this.myTicketShow = false
        setTimeout(() => {
          this.myTicketShow = true
        }, 100)
      } else if (type === 'recentTicket') {
        this.recentTicketShow = false
        setTimeout(() => {
          this.recentTicketShow = true
        }, 100)
      } else if (type === 'resolvedTicket') {
        this.resolvedTicketShow = false
        setTimeout(() => {
          this.resolvedTicketShow = true
        }, 100)
      } else if (type === 'allTicket') {
        this.allTicketShow = false
        setTimeout(() => {
          this.allTicketShow = true
        }, 100)
      }
    },
    retryCallConnect () {
      if (!this.isUseCall) return
      setTimeout(() => {
        if (this.callRetryCount < 5) {
          this.$store.dispatch('call_connect')
          this.callRetryCount += 1
        } else {
          console.log('server error')
        }
      }, 500)
    },
    retryCallApiConnect () {
      if (!this.isUseCall || !this.isPermission) return
      setTimeout(() => {
        if (this.callApiRetryCount < 5) {
          if (this.callMode === 'KT') {
            if (this.IS_CONNECTED === true) {
              this.brandSubscribe()
              this.$store.dispatch('call_api_connect', 'KT')
            }
          } else {
            this.$store.dispatch('call_api_connect')
          }
          this.callApiRetryCount += 1
        } else {
          console.log('server error')
        }
      }, 500)
    },
    retryStatusConnect () {
      if (!this.isUseCall) return
      setTimeout(() => {
        if (this.statusRetryCount < 5) {
          this.$store.dispatch('call_status_connect')
          this.statusRetryCount += 1
        } else {
          console.log('server error')
        }
      }, 500)
    },
    brandSubscribe: function () {
      this.axios({
        url: '/api/brand/subscribeUrls',
        method: 'post'
      }).then(res => {
        if (res.status !== 200 || res.data.code !== 0) {
          this.$alertMsg(res.data ? res.data.message : res.statusText)
          return false
        }
        res.data.data.forEach(item => {
          this.subscribe(
            {
              key: 'call-brandSubscribeUrl-' + item.brandId,
              subscribeUrl: item.subscribeUrl,
              callback: this.subscribeBrand
            }
          )
        })
      })
    },
    subscribeBrand (body) {
      // 실제 call 관련 subscribe 구현 예정
      // console.log('>>>>> subscribeBrand: ', body)
    },
    callApiCallbackkSubscribe () {
      this.changeCallApiUserId(this.loginId)
      // this.notification()
      this.callApiSubScribe({
        subscribeUrl: `/api/call/subscribe/callback/${this.loginId}`,
        callBack: this.fnAlarm
      })
    },
    fnAlarm (data) {
      if (this.callMode === 'KT' && data.changeType === 'NOTIFY_CALLBACK') {
        this.notifyCallbackKT(data)
        return
      }

      if (data.length > 0) {
        if (data[0].type === 'ASSING') {
          let totalCalllback = 0
          const callbackData = data.filter(d => d.callbackType === 'CB01')
          if (callbackData && callbackData.length > 0) {
            totalCalllback += callbackData.length
            this.$eventBus.$emit('reservation-update')
            this.$toasted.info(`<div class=“callNoticeToast”><dl><dt>コールバック予約(${callbackData.length} 件)が割当てられました。</dt><dd class=“data”>${moment().format('MM.DD')} <span style="color: #00A6FF">${moment().format('HH:mm')}</span></dd></dl></div>`, {
              position: `top-right`,
              duration: 10000
            })
          }
          const callbackMultiData = data.filter(d => d.callbackType === 'CB04')
          if (callbackMultiData && callbackMultiData.length > 0) {
            totalCalllback += callbackMultiData.length
            this.$eventBus.$emit('reservation-update')
            this.$toasted.info(`<div class=“callNoticeToast”><dl><dt>大容量予約(${callbackMultiData.length} 件)が割当てられました。</dt><dd class=“data”>${moment().format('MM.DD')} <span style="color: #00A6FF">${moment().format('HH:mm')}</span></dd></dl></div>`, {
              position: `top-right`,
              duration: 10000
            })
          }

          if (Notification.permission !== 'granted') {
            console.log('notification is disabled')
          } else {
            let notification = new Notification('相談割当て通知', {
              icon: `https://public-common-sdk-outaigate.s3.ap-northeast-3.amazonaws.com/image/outaigate_alram.png`,
              body: `予約相談 ${totalCalllback}件が割当てられました。`,
              requireInteraction: false
            })
            notification.error = function () {
              console.log('notification error')
            }
          }
        } else if (data[0].type === 'ALARM') {
          data.forEach(d => {
            const minute = moment(d.callbackDt, 'YYYY-MM-DD HH:mm:ss').format('YYYYMMDDHHmm') - moment().format('YYYYMMDDHHmm')
            if (minute === 10) {
              this.$toasted.show(`<div class=“callNoticeToast callIcon”><dl><dt>予約 <strong>10分前</strong> 通知です。</dt><dd class=“data”>${this.$moment(d.callbackDt).format('YYYY-MM-DD')} <span style="color: #00A6FF">${this.$moment(d.callbackDt).format('HH:mm')}</span></dd></dl></div>`, {
                position: 'top-right',
                duration: 10000
              })

              if (Notification.permission !== 'granted') {
                console.log('notification is disabled')
              } else {
                let notification = new Notification('予約相談通知', {
                  icon: `https://public-common-sdk-outaigate.s3.ap-northeast-3.amazonaws.com/image/outaigate_alram.png`,
                  body: `予約相談 ${minute}分前です。`,
                  requireInteraction: true
                })
                notification.error = function () {
                  console.log('notification error')
                }
              }
            }
          })
        }
      }
    },
    notifyCallbackKT (callbackData) {
      const { data } = callbackData
      if (data.length > 0) {
        data.forEach(d => {
          const reservationDate = moment(`${d.reservationDate} +0000`, 'YYYYMMDDHHmmss Z')
          const minute = reservationDate.format('YYYYMMDDHHmm') - moment().format('YYYYMMDDHHmm')

          if (minute === 10) {
            this.$toasted.show(`<div class=“callNoticeToast callIcon”><dl><dt>予約 <strong>${minute}分前</strong> 通知です。</dt><dd class=“data”>${reservationDate.format('YYYY-MM-DD')} <span style="color: #00A6FF">${reservationDate.format('HH:mm')}</span></dd></dl></div>`, {
              position: 'top-right',
              duration: 10000
            })

            if (Notification.permission !== 'granted') {
              console.log('notification is disabled')
            } else {
              let notification = new Notification('予約相談通知', {
                icon: 'https://public-common-sdk-outaigate.s3.ap-northeast-3.amazonaws.com/image/outaigate_alram.png',
                body: `予約相談 ${minute}分前です。`,
                requireInteraction: true
              })
              notification.error = function () {
                console.log('notification error')
              }
            }
          }
        })
      }
    }
  },
  watch: {
    currentBrandId (newVal) {
      if (Number.isInteger(newVal)) {
        this.checkUseCall()
      }
    }
  }
}

export default wsConnection



// WEBPACK FOOTER //
// ./src/util/wsConnection.js